import React from "react";
import { PixTemplate } from "../../Templates/PixTemplate";

export const Pix = () => {
  return <PixTemplate />;
};
